<div class="dialog-container" id="changeCategory">
  <form class="needs-validation" [formGroup]="indexationFormGroup">
    <h5 class="modal-header">تعديل التوصيف</h5>
    <div mat-dialog-content>
      <div class="row">
        <div class="col-md-12">
          <app-switch-input
            [labelEn]="'is_default'"
            [labelDesc]="'(نشط/غير نشط)'"
            [index]="2"
            [value]="data.indexationItem.is_default"
            (valueChanged)="isActiveValueChanged($event)"
          >
          </app-switch-input>
        </div>

        <div class="col-md-12">
          <div class="form-group">
            <label for="" class="form-label">التوصيف للفاحص</label>
            <input type="text" class="form-control" formControlName="name" />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="" class="form-label">التوصيف للعميل</label>
            <input
              type="text"
              class="form-control"
              formControlName="description"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="" class="form-label"> سعر الوحدة</label>
            <input
              type="number"
              class="form-control"
              formControlName="unit_cost"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="" class="form-label">وحدة القياس</label>
            <ng-select
              bindLabel="name"
              formControlName="unit_of_measurement"
              placeholder="وحدة القياس"
              appendTo="body"
              [searchable]="true"
              [virtualScroll]="true"
              [clearable]="true"
            >
              @for (unit of data?.unitMeasurement; track unit) {
              <ng-option [value]="unit.id">
                {{ unit.name }}
              </ng-option>
              }
            </ng-select>
          </div>
        </div>
        <div class="col-md-12">
          <app-switch-input
            [labelEn]="'update_old_notes'"
            [labelDesc]="'(تحديث الملاحظات القديمة)'"
            [index]="1"
            [value]="indexationFormGroup.get('update_old_notes').value"
            (valueChanged)="isActiveValueChanged($event)"
          >
          </app-switch-input>
        </div>
      </div>
    </div>
    <div mat-dialog-actions class="actions-double">
      <a class="btn btn-cancel center-btn" mat-dialog-close>إلغاء</a>
      <button
        class="btn btn-green center-btn"
        type="button"
        (click)="save()"
        [disabled]="disable"
      >
        تعديل
      </button>
    </div>
  </form>
</div>
